<template>
  <div class="profile-job-wrapper">
    <h3>Job</h3>

    <div class="profile-job">
      <job-summary />
      <work-rules />
      <payment-info @open="$emit('open')" @externalLink="$emit('externalLink', $event)" />
      <activity-info :associate-id="associate.id" />
      <training-info v-if="!isStaff" />
      <license-info v-if="isProfessionalLicenseRequired" />
      <identifiers-info />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ProfileActivityInfo from './activity.vue'
import ProfileIdentifiersInfo from './identifiers.vue'
import ProfileJobSummary from './summary.vue'
import ProfileLicenseInfo from './license.vue'
import ProfileViewPay from './payment.vue'
import ProfileWorkRules from './work-rules.vue'
import Training from './training.vue'

const { mapState: profileState } = createNamespacedHelpers('profile')

export default {
  components: {
    'activity-info': ProfileActivityInfo,
    'identifiers-info': ProfileIdentifiersInfo,
    'job-summary': ProfileJobSummary,
    'license-info': ProfileLicenseInfo,
    'payment-info': ProfileViewPay,
    'training-info': Training,
    'work-rules': ProfileWorkRules
  },
  computed: {
    ...profileState({
      associate: state => state.associate,
      compliance: state => state.associateCompliance
    }),
    isProfessionalLicenseRequired() {
      return this.compliance?.required_associate_docs?.some(item => item.template?.name === 'Professional License')
    },

    isStaff() {
      return this.$store.state.applicationState.currentProject.staffing
    }
  }
}
</script>

<style scoped>
.profile-job-wrapper,
.profile-job {
  display: flex;
  flex-direction: column;
}

.profile-job-wrapper {
  gap: 16px;
}

.profile-job {
  min-width: 0;
  gap: 4px;
}
</style>
